import axios_instance from './liveChatAxiosInst';

async function setNewMessage (
        operatorId,
        chatId,
        userId,
        chatIssue,
        continuationNb,
        message,
        dispatch,
        state,
    ) {
    await axios_instance.post(
        process.env.REACT_APP_LIVE_CHAT_API,
        {
            action: "newHotlineMessage",
            operator_id: operatorId,
            chat_id: chatId,
            user_id: userId,
            chat_issue: chatIssue,
            continuation_nb: continuationNb,
            message: message,
            pseudo: state.pseudo,
        },
    )
    .then (resp => {
        if (resp.status === 200) {
            dispatch({type: 'change_com_list', payload: {com_list: resp.data.comList}})
        } else {
            dispatch({type: 'change_com_list', payload: {com_list: []}});
        }
    })
    .catch (() => dispatch({type: 'change_com_list', payload: {com_list: []}}));
}

export default setNewMessage;